// src/components/Auth/Login.jsx
// Shows clear message when account is blocked or subscription expired

import { useState } from "react";
import { Link } from "react-router-dom";
import { API_BASE_URL } from "../../config/api";
import PasswordInput from "../PasswordInput";

const Login = () => {
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState(null); // { type, message }

  const handleLogin = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem("token",     data.token);
        localStorage.setItem("ownerRole", data.role);

        if (data.role === "admin") {
          window.location.href = "/admin/dashboard";
        } else {
          window.location.href = "/owner/dashboard";
        }
      } else {
        // ── Handle specific error types ──────────────────────
        if (data.blocked) {
          setError({ type: "blocked", message: data.message });
        } else if (data.subscriptionExpired) {
          setError({ type: "expired", message: data.message });
        } else {
          setError({ type: "general", message: data.message || "Invalid email or password." });
        }
      }
    } catch {
      setError({ type: "general", message: "Backend not running. Please try again." });
    }

    setLoading(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleLogin();
  };

  return (
    <div className="auth-form">
      <h2>Hello !</h2>
      <p className="subtitle">Welcome to FDS</p>

      {/* ── Error Messages ── */}
      {error && (
        <div style={{
          padding: "14px 16px",
          borderRadius: 10,
          marginBottom: 16,
          border: `1.5px solid ${error.type === "blocked" ? "#fecaca" : error.type === "expired" ? "#fed7aa" : "#fecaca"}`,
          background: error.type === "blocked" ? "#fee2e2" : error.type === "expired" ? "#fff7ed" : "#fee2e2",
        }}>
          <div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
            <span style={{ fontSize: 20, flexShrink: 0 }}>
              {error.type === "blocked" ? "🚫" : error.type === "expired" ? "⏰" : "⚠️"}
            </span>
            <div>
              <div style={{
                fontWeight: 700, fontSize: 14,
                color: error.type === "blocked" ? "#991b1b" : error.type === "expired" ? "#92400e" : "#991b1b",
                marginBottom: 4,
              }}>
                {error.type === "blocked"  ? "Account Blocked"           :
                 error.type === "expired"  ? "Subscription Expired"      :
                                             "Login Failed"}
              </div>
              <div style={{
                fontSize: 13,
                color: error.type === "blocked" ? "#b91c1c" : error.type === "expired" ? "#b45309" : "#b91c1c",
                lineHeight: 1.5,
              }}>
                {error.message}
              </div>
              {error.type === "expired" && (
                <div style={{ marginTop: 8, fontSize: 12, color: "#92400e" }}>
                  Contact your administrator to renew your subscription.
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <input
        type="email"
        placeholder="Email Address"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        onKeyDown={handleKeyDown}
      />

      <PasswordInput
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        onKeyDown={handleKeyDown}
      />

      <p className="forgot-link">
        <Link to="/forgot-password">Forgot Password?</Link>
      </p>

      <button
        className="primary-btn"
        onClick={handleLogin}
        disabled={loading}
      >
        {loading ? "Logging in..." : "Login"}
      </button>

      <p className="link-text">
        <Link to="/register">Register Here</Link>
      </p>
    </div>
  );
};

export default Login;
